<template>
  <el-dialog
      :model-value="props.visible"
      title="正常工资薪金所得"
      width="600"
      top="6vh"
      destroy-on-close
      :close-on-click-modal="false"
      @open="onOpen"
      @closed="closedModal"
  >
    <div v-loading="pageLoading">
      <div class="content-wrap">
        <el-radio-group
            class="my-guide-radio"
            v-model="guideType">
          <el-radio label="复制上月当期数据(不包含专项附加扣除数据，用户需手工补充)" value="1"/>
          <el-radio label="标准模板导入" value="2"/>
          <el-radio label="生成零工资记录，用户手工修改" value="3"/>
        </el-radio-group>
      </div>

      <div class="my-footer">
        <el-button @click="emit('update:visible', false)">关闭</el-button>
        <el-button
            type="primary"
            style="margin-right: 15px;"
            @click="download">导入
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import {ElMessage, ElMessageBox} from "element-plus";

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  currentRow: {
    type: Object,
    default: () => {
    }
  }
})

const pageLoading = ref(false)
const guideType = ref('')

function onOpen() {
}

function download() {
  if (guideType.value == '') {
    ElMessage.warning('请选择操作方式')
    return
  }
  if (guideType.value != '3') {
    return
  }
  emit('exeInit')
  emit('update:visible', false)
}


const emit = defineEmits(['update:visible', 'exeInit'])

function closedModal() {
  emit('update:visible', false)
  guideType.value = ''
}
</script>

<style scoped lang="scss">
.my-footer {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 30px;
}


:deep(.my-guide-radio) {
  &.my-guide-radio {
    display: block;
  }

  .el-radio {
    display: block;
  }
}

.content-wrap {
  margin-top: 20px;
}
</style>
